import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";
// import moment from "moment";
import "./Homepage.styles.css";
// import { useNavigate } from "react-router-dom";
// import callMob from "../../assets/images/flight/book-tick.png";
import { phoneNum } from "../../utils/globalVars";
// import { useState } from "react";
import SEO from "../../utils/SEO";
import BestTour from "../../components/BestTours/BestTour";
import BestTourAu from "../../components/BestTours/BestTourAu";
import BestTourCa from "../../components/BestTours/BestTourCa";
import BestTourIn from "../../components/BestTours/BestTourIn";
import BestTourNz from "../../components/BestTours/BestTourNz";
import BestTourPh from "../../components/BestTours/BestTourPh";
import BestTourQa from "../../components/BestTours/BestTourQa";
import BestTourRp from "../../components/BestTours/BestTourRp";
import BestTourSg from "../../components/BestTours/BestTourSg";
import BestTourUAE from "../../components/BestTours/BestTourUAE";
import BestTourHk from "../../components/BestTours/BestTourHk";
import BestTourMy from "../../components/BestTours/BestTourMy";
import BestTourZa from "../../components/BestTours/BestTourZa";
import BestTourTh from "../../components/BestTours/BestTourTh";
import BestTourUk from "../../components/BestTours/BestTourUk";
import BestTourVn from "../../components/BestTours/BestTourVn";
import moment from "moment";
import testimonials from "../../assets/images/flight/beach-blue-sky.jpg";
import sydney from "../../assets/images/flight/sydney.jpg";
import london from "../../assets/images/flight/london.jpg";
import uk from "../../assets/images/flight/uk.jpg";
import toronto from "../../assets/images/flight/toronto.jpg";
import york from "../../assets/images/flight/new york.jpg";
import singapore from "../../assets/images/flight/singapore.jpg";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  // const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  // const handleExpClick = (origin, dest) => {
  //   navigate({
  //     pathname: "/flights",
  //     search: `?search_t=${moment().unix()}&tripType=one-way&dep_loc=${origin}&dest_loc=${dest}&dep_dt=${moment().format(
  //       "YYYY-MM-DD"
  //     )}&ret_dt=null&fl_cl=ECONOMY&adt=1&chd=0`,
  //   });
  // };

  // const [showPopup, setPopup] = useState('active')

  // function removePopup(){
  //   setPopup('')
  // }

  const handleExpClick = (origin, dest) => {
    localStorage.setItem(
      "formValue",
      JSON.stringify({
        startDate: moment().format("YYYY-MM-DD"),
        passengers: {
          adults: 1,
          child: 0,
        },
        departureVal: {
          iataCode: origin,
        },
        arrVal: {
          iataCode: dest,
        },
        tripType: "one-way",
      }),
    );
    navigate({
      pathname: "/flights",
      search: `?search_t=${moment().unix()}&tripType=one-way&dep_loc=${origin}&dest_loc=${dest}&dep_dt=${moment().format(
        "YYYY-MM-DD",
      )}&ret_dt=null&fl_cl=ECONOMY&adt=1&chd=0`,
    });
  };

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const loadBestTour = () => {
    let urlname;
    urlname = window.location.hostname.split(".")[0];
    if (urlname === "localhost") {
      urlname = "en";
    } else {
      if (urlname === "www") {
        urlname = "en";
      }
    }

    return (
      <>
        {urlname === "Airefare" ? <BestTour /> : ""}
        {urlname === "au" ? <BestTourAu /> : ""}
        {urlname === "ca" ? <BestTourCa /> : ""}
        {urlname === "hk" ? <BestTourHk /> : ""}
        {urlname === "in" ? <BestTourIn /> : ""}
        {urlname === "id" ? <BestTourRp /> : ""}
        {urlname === "my" ? <BestTourMy /> : ""}
        {urlname === "nz" ? <BestTourNz /> : ""}
        {urlname === "ph" ? <BestTourPh /> : ""}
        {urlname === "qa" ? <BestTourQa /> : ""}
        {urlname === "sg" ? <BestTourSg /> : ""}
        {urlname === "sa" ? <BestTourZa /> : ""}
        {urlname === "th" ? <BestTourTh /> : ""}
        {urlname === "en" ? <BestTour /> : ""}
        {urlname === "es" ? <BestTour /> : ""}
        {urlname === "ae" ? <BestTourUAE /> : ""}
        {urlname === "uk" ? <BestTourUk /> : ""}
        {urlname === "vn" ? <BestTourVn /> : ""}
      </>
    );
  };
  return (
    <>
      <SEO
        title="Airefare - Ultimate Destination for Cheap Flight Booking"
        description="Airefare - Your ultimate destination for hassle-free travel bookings. Find the best deals on flights, and embark on your dream journey today. Visit us"
      />

      <div className="home-banner">
        <div className="rounded-banner-overlay">
          <div className="rounded-banner">
            <p className="tagline">
              Travel smarter with exclusive flight deals
            </p>
            <h1 className="main-heading">
              Great deals to your favorite destinations
            </h1>
            <div className="price-section">
              <p className="sub-text">Flights starting from</p>
              <h2 className="price">$100</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="cm-page-center">
        <div className="search-banner">
          <FlightSearchForm />
        </div>
      </div>

      <section className="travel-offers-sec">
        <div className="cm-page-center">
          <h2 className="travel-heading">Explore our best travel deals</h2>
          <div className="travel-grid">
            <div
              className="travel-card"
              onClick={(e) => handleExpClick("JFK", "LHR")}
            >
              <div className="travel-img-box">
                <img src={london} />
                <div className="travel-overlay"></div>
                <span className="travel-price">$155</span>
              </div>
              <div className="travel-info">
                <h3>Paris Escape</h3>
                <p>JFK → LHR</p>
              </div>
            </div>
            <div
              className="travel-card"
              onClick={(e) => handleExpClick("MAD", "LHR")}
            >
              <div className="travel-img-box">
                <img src={sydney} />
                <div className="travel-overlay"></div>
                <span className="travel-price">$100</span>
              </div>
              <div className="travel-info">
                <h3>Spain Adventure</h3>
                <p>MAD → LHR</p>
              </div>
            </div>
            <div
              className="travel-card"
              onClick={(e) => handleExpClick("ATL", "JFK")}
            >
              <div className="travel-img-box">
                <img src={toronto} />
                <div className="travel-overlay"></div>
                <span className="travel-price">$120</span>
              </div>
              <div className="travel-info">
                <h3>Egypt Wonders</h3>
                <p>ATL → JFK</p>
              </div>
            </div>
            <div
              className="travel-card"
              onClick={(e) => handleExpClick("SYD", "LHR")}
            >
              <div className="travel-img-box">
                <img src={uk} />
                <div className="travel-overlay"></div>
                <span className="travel-price">$147</span>
              </div>
              <div className="travel-info">
                <h3>Boston Skyline</h3>
                <p>SYD → LHR</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cm-live-section">
        <div className="cm-page-center">
          <h2 className="cm-title">Trending Flight Deals Right Now</h2>
          <div className="cm-live-grid">
            <div className="cm-live-stats">
              <div className="cm-stat-box">
                <h3>247+</h3>
                <p>Flights booked today</p>
              </div>
              <div className="cm-stat-box">
                <h3>120+</h3>
                <p>Airlines available</p>
              </div>
              <div className="cm-stat-box">
                <h3>98%</h3>
                <p>Customer satisfaction</p>
              </div>
            </div>
            <div className="cm-live-deals">
              <div className="cm-deal-card">
                <div>
                  <h4>New York → Paris</h4>
                  <span>2 mins ago</span>
                </div>
                <p>$320</p>
              </div>
              <div className="cm-deal-card">
                <div>
                  <h4>Dubai → London</h4>
                  <span>5 mins ago</span>
                </div>
                <p>$280</p>
              </div>
              <div className="cm-deal-card">
                <div>
                  <h4>Egypt → Toronto</h4>
                  <span>8 mins ago</span>
                </div>
                <p>$540</p>
              </div>
              <div className="cm-deal-card">
                <div>
                  <h4>Sydney → Singapore</h4>
                  <span>12 mins ago</span>
                </div>
                <p>$190</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cm-why-section">
        <div className="cm-page-center">
          <h2 className="cm-heading">Why Choose Airfare</h2>
          <div className="cm-why-grid">
            <div className="cm-why-left">
              <div className="cm-why-card">
                <div className="cm-icon">💸</div>
                <h3>Best Price Guarantee</h3>
                <p>
                  We compare hundreds of airlines to bring you the lowest fares.
                </p>
              </div>
              <div className="cm-why-card">
                <div className="cm-icon">⚡</div>
                <h3>Instant Booking</h3>
                <p>Book your flight in seconds with real-time confirmations.</p>
              </div>
              <div className="cm-why-card">
                <div className="cm-icon">🔁</div>
                <h3>Easy Cancellation</h3>
                <p>
                  Flexible cancellation and refund options for peace of mind.
                </p>
              </div>
              <div className="cm-why-card">
                <div className="cm-icon">📞</div>
                <h3>24/7 Support</h3>
                <p>Our travel experts are always available to assist you.</p>
              </div>
            </div>
            <div className="cm-why-right">
              <h3>Trusted by Travelers Worldwide ✈️</h3>
              <p>
                Join thousands of happy travelers who rely on us for affordable,
                fast, and reliable flight bookings across the globe.
              </p>
              <div className="cm-highlight-stats">
                <div>
                  <h4>500+</h4>
                  <span>Airlines</span>
                </div>
                <div>
                  <h4>1M+</h4>
                  <span>Bookings</span>
                </div>
                <div>
                  <h4>98%</h4>
                  <span>Satisfaction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="txr-promo-wrapper">
        <div className="cm-page-center">
          <div className="txr-promo-grid">
            <div className="txr-offer-box">
              <div className="txr-offer-badge">LIMITED OFFER</div>
              <h2 className="txr-offer-title">
                Unlock <span>$15 Savings</span>
                <br />
                on Your Next Trip ✈️
              </h2>
              <p className="txr-offer-desc">
                Join now and get exclusive discounts on international
                destinations.
              </p>
              <div className="txr-email-box">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="txr-email-input"
                />
                <button className="txr-email-btn">Claim Deal</button>
              </div>
              <div className="txr-offer-note">⏳ Limited time only</div>
            </div>
            <div className="txr-call-box">
              <h3 className="txr-call-title">Talk to a Travel Expert</h3>
              <div className="txr-feature-list">
                <div className="txr-feature-item">
                  ✔ Instant booking confirmation
                </div>
                <div className="txr-feature-item">
                  ✔ 24/7 cancellation support
                </div>
                <div className="txr-feature-item">
                  ✔ Flexible payment options
                </div>
                <div className="txr-feature-item">
                  ✔ Personalized travel planning
                </div>
              </div>
              <a href="tel:+18773279309" className="txr-call-btn">
                📞 Call Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
